<template>
  <div class="header">
    <div class="l-header">
      <div class="logo-mark">
        <el-image :src="systemLogo" class="image"></el-image>
      </div>
      <h3 class="sys-name">{{ systemName }}</h3>
    </div>

    <div class="m-header">
      <el-menu :default-active="menuIndex" class="el-menu-demo" mode="horizontal"
               background-color="transparent" text-color="rgba(255,255,255,0.72)" active-text-color="#ffffff"
               @select="handleSelect">
        <el-menu-item v-for="(item) in menuData" :key="item.label" :index="item.name">
          {{ item.label }}
        </el-menu-item>
      </el-menu>
    </div>

    <div class="r-header">
      <div class="user-chip">
        <el-popover
            placement="top-start"
            width="180"
            trigger="hover">
          <div v-for="(item, index) in showInfoDetail" :key="index" class="user-pop-item">{{ item }}</div>
          <div slot="reference" class="user-name line-clamp-1">
            <span class="avatar">{{ avatarChar }}</span>
            {{ showInfoRight }}
          </div>
        </el-popover>
      </div>
      <el-dropdown @command="handleClick">
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu>
          <el-dropdown-item v-for="(item, index) in dropData" :key="index" :command="item.command">
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MyHeader',
  props: ['menuIndex', 'menuData', 'mainClick', 'sysClick', 'dropData'],

  data() {
    return {
      showInfoRight: "",
      showInfoDetail: []
    }
  },

  mounted() {
    this.$store.dispatch("setupSystemSetting")
    if (this.$store.state.accountType === "manage") {
      let account = this.$store.state.loginInfo
      this.showInfoRight = account.name
      this.showInfoDetail.push("账号：" + account.name)
    } else {
      let account = this.$store.state.employeeLoginInfo
      let str = account.name + ", " + account.workId + ", " + account.departmentName
      this.showInfoRight = str
      this.showInfoDetail.push("姓名：" + account.name)
      this.showInfoDetail.push("工号：" + account.workId)
      this.showInfoDetail.push("部门：" + account.departmentName)
    }

  },

  methods: {

    handleSelect(index) {
      this.mainClick(index)
    },

    handleClick(command) {
      this.sysClick(command)
    }
  },

  computed: {
    systemName() {
      let name = this.$store.state.systemSetting.systemName
      return name ? name : "管理中台"
    },
    systemLogo() {
      let logo = this.$store.state.systemSetting.companyLogo
      return logo ? logo : require('../assets/icon.png')
    },
    avatarChar() {
      let name = this.showInfoRight || ""
      return name.trim().charAt(0).toUpperCase() || "U"
    }
  },

}
</script>

<style lang="less" scoped>

.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  height: 64px;
  background: linear-gradient(90deg, #0b1739 0%, #101f4e 60%, #14275e 100%);
  box-shadow: 0 2px 12px rgba(11, 23, 57, 0.25);

  .l-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 24px;
    color: white;
    width: 210px;
    flex-shrink: 0;

    .logo-mark {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      margin-right: 10px;
      border-radius: 9px;
      background: linear-gradient(135deg, #2563eb, #4f46e5);
      box-shadow: 0 4px 14px rgba(37, 99, 235, 0.4);
      overflow: hidden;
    }

    .image {
      width: 22px;
      height: 22px;
    }

    .sys-name {
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
      color: #fff;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .m-header {
    height: 64px;
    flex: 1;
    min-width: 0;

    .el-menu--horizontal {
      border-bottom: 0;
      height: 64px;
    }

    /deep/ .el-menu-item {
      height: 64px;
      line-height: 64px;
      font-size: 14px;
      letter-spacing: 1px;
      border-bottom: none;
      transition: all 0.2s ease;

      &:hover {
        background-color: rgba(255, 255, 255, 0.06) !important;
        color: #fff !important;
      }
    }

    /deep/ .el-menu-item.is-active {
      background-color: transparent !important;
      position: relative;
      font-weight: 600;

      &::after {
        content: "";
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 10px;
        height: 3px;
        border-radius: 2px;
        background: linear-gradient(90deg, #60a5fa, #a5b4fc);
      }
    }
  }

  .r-header {
    height: 64px;
    padding-right: 24px;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .user-chip {
      display: flex;
      align-items: center;
      height: 36px;
      padding: 0 12px;
      margin-right: 6px;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.12);
      cursor: pointer;
      transition: background 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.14);
      }
    }

    .user-name {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.9);
      max-width: 220px;
    }

    .avatar {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      margin-right: 8px;
      border-radius: 50%;
      background: linear-gradient(135deg, #60a5fa, #818cf8);
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      flex-shrink: 0;
    }

    .el-dropdown-link {
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.72);
      cursor: pointer;
    }

    .el-dropdown {
      height: 64px;
      line-height: 64px;
    }
  }
}

.user-pop-item {
  font-size: 13px;
  color: #4b5563;
  line-height: 1.9;
}

</style>
